import { render, staticRenderFns } from "./NovoCartaoCredito.vue?vue&type=template&id=31f2ae02"
import script from "./NovoCartaoCredito.vue?vue&type=script&lang=js"
export * from "./NovoCartaoCredito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports